import React from 'react';
import { Box, Container, Typography } from '@material-ui/core';

import DeliverySection from './DeliverySection/DeliverySection';
import notebookIcon from 'public/icons/notes.svg';
import walletIcon from 'public/icons/wallet.svg';
import truckShippedIcon from 'public/icons/truck-shipped.svg';
import returnIcon from 'public/icons/return-box.svg';
import {
  ADVANCED_PAYMENT_FOR_CASH_ON_DELIVERY,
  MIN_CASH_ON_DELIVERY_PRICE,
  MIN_FREE_DELIVERY_PRICE,
  MIN_ORDER_PRICE
} from 'domain/constants';

const Delivery: React.FC = (): JSX.Element => {
  return (
    <Container>
      <Box mb={16}>
        <DeliverySection title="ЯК ЗРОБИТИ ЗАМОВЛЕННЯ?" image={notebookIcon} color="primary" fixIcon>
          <ul>
            <Typography component="li" variant="h5">
              Оформити замовлення на сайті можна ЦІЛОДОБОВО;
            </Typography>
            <Typography component="li" variant="h5">
              Мінімальна сума замовленння - {MIN_ORDER_PRICE} грн;
            </Typography>
            <Typography component="li" variant="h5">
              Після оформлення ми надішлемо повідомлення з номером вашого замовлення та реквізитами
              для оплати у Viber або SMS.
            </Typography>
            <Typography component="li" variant="h5">
              Переглянути статус замовлення ви можете у вкладці “Відстежити замовлення”;
            </Typography>
            <Typography component="li" variant="h5">
              Замовлення, оформлені після 19.00, опрацьовуються наступного дня.
            </Typography>
          </ul>
        </DeliverySection>

        <DeliverySection title="ЯК ОПЛАТИТИ?" image={walletIcon} color="info">
          <Typography variant="h6" component="h3">
            Карткою на сайті
          </Typography>
          <ul>
            <Typography component="li" variant="h5">
              Оплата онлайн через сервіс LiqPay одразу при оформленні замовлення (Visa, Mastercard,
              Apple Pay, Google Pay).
            </Typography>
          </ul>

          <Typography variant="h6" component="h3">
            Оплата на рахунок
          </Typography>
          <ul>
            <Typography component="li" variant="h5">
              Після підтвердження замовлення ми надішлемо реквізити IBAN у Viber або SMS;
            </Typography>
            <Typography component="li" variant="h5">
              Замовлення потрібно оплатити протягом 24 годин з моменту підтвердження, в іншому разі
              бронювання товару скасовується.
            </Typography>
          </ul>

          <Typography variant="h6" component="h3">
            Оплата у відділенні Нової Пошти
          </Typography>
          <ul>
            <Typography component="li" variant="h5">
              Обравши цей метод оплати, ви також сплачуєте комісію Нової Пошти за переказ коштів;
            </Typography>
            <Typography component="li" variant="h5">
              Накладний платіж можливий при передоплаті {ADVANCED_PAYMENT_FOR_CASH_ON_DELIVERY} грн
              на карту для замовлень {MIN_CASH_ON_DELIVERY_PRICE} грн та вище.
            </Typography>
          </ul>
        </DeliverySection>

        <DeliverySection title="ЯК ОТРИМАТИ ЗАМОВЛЕННЯ?" image={truckShippedIcon} color="secondary">
          <ul>
            <Typography component="li" variant="h5">
              Замовлення відправляються протягом 2-3 днів з моменту підтвердження оплати;
            </Typography>
            <Typography component="li" variant="h5">
              Відправка замовлень відбувається в робочі дні з понеділка по п’ятницю;
            </Typography>
            <Typography component="li" variant="h5">
              Вартість та терміни доставки - згідно з тарифами Нової Пошти;
            </Typography>
          </ul>

          <Typography variant="h6" component="h3">
            * при замовленні від {MIN_FREE_DELIVERY_PRICE} грн - доставка БЕЗКОШТОВНА
          </Typography>
        </DeliverySection>

        <DeliverySection title="ЯК ПОВЕРНУТИ АБО ОБМІНЯТИ ТОВАР?" image={returnIcon} color="primary">
          <ul>
            <Typography component="li" variant="h5">
              Придбаний товар можна повернути або обміняти на інший протягом 14 днів при умові, що
              він не був у використанні та збережена оригінальна упаковка;
            </Typography>
            <Typography component="li" variant="h5">
              Доставку повернення оплачує покупець;
            </Typography>
            <Typography component="li" variant="h5">
              Кошти повертаємо банківським переказом протягом 7 робочих днів після отримання
              повернення;
            </Typography>
            <Typography component="li" variant="h5">
              Якщо у товарі виявлено недолік - напишіть нам, і ми докладемо всіх зусиль, щоб швидко
              вирішити проблему.
            </Typography>
          </ul>

          <Typography variant="h6" component="h3">
            * детальні умови повернення - у{' '}
            <a href="/oferta.pdf" target="_blank" rel="noreferrer">
              договорі оферти
            </a>
          </Typography>
        </DeliverySection>
      </Box>
    </Container>
  );
};

export default Delivery;
